module.exports = __webpack_public_path__ + "static/magnus-monitors-approved-supplier-e934fe86c7b24299106fb2076595fb97.svg";